// removed by extract-text-webpack-plugin
module.exports = {"root":"CurrentPackage__root___1dSCm","services":"CurrentPackage__services___2Tv7A"};